export default __webpack_public_path__ + "static/media/trace_teachers_title.8555b607.svg";